exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.text-grey-light[data-v-20e1b5aa]{color:rgba(0,0,0,0.54)\n}\n", "", {"version":3,"sources":["/builds/w3-groupe/openfly/openfly/resources/assets/js/components/registration/Profile/formSimple.vue"],"names":[],"mappings":";AAAA,kCAAiB,sBAAsB;CAAC","file":"formSimple.vue","sourcesContent":[".text-grey-light{color:rgba(0,0,0,0.54)}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20e1b5aa","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/registration/Profile/formSimple.vue
// module id = ./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-20e1b5aa","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/registration/Profile/formSimple.vue
// module chunks = 1 2 3